// Use server-computed permissions; retain compatibility with older API responses.
export const canManageGame = (game, userId) => !!userId &&
  (typeof game?.permissions?.canManage === 'boolean' ? game.permissions.canManage : game?.admin === userId);
